
const version = require('@/../package.json').version

export default {
    data() {
        return {
            config: {
                host: process.env.VUE_APP_HOST_DOMAIN,
                apiUrl: process.env.VUE_APP_HOST_DOMAIN + process.env.VUE_APP_BASE_API,
                gameServerHost: process.env.VUE_APP_GAME_SERVER_HOST,
                disableTimeout: process.env.VUE_APP_DISABLE_TIMEOUT === 'true',
                env: process.env.VUE_APP_ENV,
                version: version
            }
        }
    }
}
